export const MEASUREMENT_NAME = 'Box Dimensions';

export const data = {
  category: null,
  isOpen: false,
  showDimensions: false,
}
